import { Card, Flex, Space, Statistic, Typography } from 'antd';
import PropTypes from 'prop-types';
import { formatNumber } from '@/common/utils/format';
import {
  formatAnalysisTimestamp,
  formatDelta,
  getDeltaTextType,
  getMetricTitle,
} from '../utils/analysis';

const AnalysisMetricCard = ({ item }) => (
  <Card
    extra={formatAnalysisTimestamp(item.asOf)}
    size="small"
    styles={{ extra: { fontSize: 10 } }}
    type="inner"
    title={getMetricTitle(item.key)}
  >
    <Flex vertical gap="middle">
      <Statistic value={item.value || 0} formatter={(value) => formatNumber(value)} />
      <Space wrap>
        <Typography.Text type="secondary">较上周</Typography.Text>
        <Typography.Text type={getDeltaTextType(item.delta)}>
          {formatDelta(item.delta)}
        </Typography.Text>
      </Space>
    </Flex>
  </Card>
);

AnalysisMetricCard.propTypes = {
  item: PropTypes.shape({
    asOf: PropTypes.number,
    delta: PropTypes.number,
    key: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
};

export default AnalysisMetricCard;
